<div class="info-action dropdown-content-root">
	<div class="dropdown-title">
		<p class="title">{{ 'postTrading.info.titles.' + postTradingEvent?.entry_type | translate }}</p>
		<tui-icon
			class="icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="dropdown-subtitle">
		<div
			class="left"
			[tuiSkeleton]="isLoadingAssetInfo()"
		>
			<app-company-logo
				[logoSrc]="assetsInfo()?.icon"
				[symbol]="assetsInfo()?.ticker"
				logoWidth="24px"
				logoHeight="24px"
				[logoAlt]="assetsInfo()?.ticker"
			/>
			<p class="ticker">{{ assetsInfo()?.ticker }}</p>
		</div>
		<div class="right">
			<div class="ticker">
				<span class="text">
					{{ postTradingEvent?.option_strike | price }}
				</span>
				<span
					class="text"
					highlight
					[isPositive]="postTradingEvent?.option_type === optionTypeEnum.CALL"
					[isNegative]="postTradingEvent?.option_type === optionTypeEnum.PUT"
				>
					{{ postTradingEvent?.option_type | uppercase }}
				</span>
				<span class="text">
					{{ postTradingEvent?.option_date | date: 'dd.MM.yyyy' }}
				</span>
			</div>
		</div>
	</div>

	<div class="details">
		<div class="detail">
			<p class="title">{{ 'postTrading.info.status' | translate }}</p>
			<span class="value">{{ 'postTrading.info.completed' | translate }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'postTrading.info.date' | translate }}</p>
			<span class="value">{{ postTradingEvent?.settle_date | date: 'dd.MM.yyyy' }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'postTrading.info.ticker' | translate }}</p>
			<span class="value">{{ postTradingEvent?.option_symbol }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'postTrading.info.qtyContracts' | translate }}</p>
			<span class="value">{{ postTradingEvent?.qty | quantity }}</span>
		</div>
	</div>

	@if (postTradingEvent?.entry_type !== postTradingEventTypeEnum.EXPIRED) {
		<div class="details divider">
			<div class="detail">
				<p class="title">{{ 'postTrading.info.side' | translate }}</p>
				<span
					class="value"
					highlight
					[isPositive]="(postTradingEvent?.optrd_qty ?? 0) > 0"
					[isNegative]="(postTradingEvent?.optrd_qty ?? 0) < 0"
					[isNeutral]="!postTradingEvent?.optrd_qty"
				>
					{{
						((postTradingEvent?.optrd_qty ?? 0) >= 0
							? 'postTrading.info.sides.call'
							: 'postTrading.info.sides.put'
						) | translate
					}}
				</span>
			</div>

			<div class="detail">
				<p class="title">{{ 'postTrading.info.date' | translate }}</p>
				<span class="value">{{
					postTradingEvent?.optrd_date ? (postTradingEvent?.optrd_date | date: 'dd.MM.yyyy') : '-'
				}}</span>
			</div>

			<div class="detail">
				<p class="title">{{ 'postTrading.info.asset' | translate }}</p>
				<span class="value">{{ postTradingEvent?.ticker }}</span>
			</div>

			<div class="detail">
				<p class="title">{{ 'postTrading.info.qty' | translate }}</p>
				<span
					class="value"
					highlight
					[isPositive]="(postTradingEvent?.optrd_qty ?? 0) >= 0"
					[isNegative]="(postTradingEvent?.optrd_qty ?? 0) < 0"
					[isNeutral]="!postTradingEvent?.optrd_qty"
				>
					{{ (postTradingEvent?.optrd_qty ?? 0) > 0 ? '+' : '' }}{{ postTradingEvent?.optrd_qty | quantity }}
				</span>
			</div>

			<div class="detail">
				<p class="title">{{ 'postTrading.info.price' | translate }}</p>
				<span class="value">{{ postTradingEvent?.optrd_price | price }}</span>
			</div>

			<div class="detail">
				<p class="title">{{ 'postTrading.info.sum' | translate }}</p>
				<span
					class="value"
					highlight
					[isPositive]="(postTradingEvent?.optrd_net_amount ?? 0) > 0"
					[isNegative]="(postTradingEvent?.optrd_net_amount ?? 0) < 0"
					[isNeutral]="!postTradingEvent?.optrd_net_amount"
					>{{ postTradingEvent?.optrd_net_amount | price }}</span
				>
			</div>
		</div>
	}
</div>
